import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS, SERVICES } from "../data/navigation";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#00142D] text-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Link to="/" className="inline-block bg-white rounded-xl px-4 py-2.5 mb-5">
            <img src="/evontra-logo.png" alt="Evontra" className="h-8 w-auto" />
          </Link>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            Premium corporate event management and experiential events — where professional execution meets technology and innovation.
          </p>
          <Link data-testid="footer-plan-event-cta" to="/plan-your-event" className="ev-btn-primary mt-6 inline-flex items-center gap-2 text-white text-sm font-bold px-5 py-2.5 rounded-full">
            Plan Your Event <ArrowRight size={15} />
          </Link>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] font-extrabold tracking-[0.18em] uppercase text-[#32B5E8] mb-4">Solutions</p>
          <ul className="space-y-2.5">
            {SOLUTIONS.map((s) => (
              <li key={s.id}>
                <Link to={`/solutions#${s.id}`} className="text-sm text-slate-300 hover:text-white transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] font-extrabold tracking-[0.18em] uppercase text-[#32B5E8] mb-4">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm text-slate-300 hover:text-white transition-colors">{s}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[11px] font-extrabold tracking-[0.18em] uppercase text-[#8BCB32] mb-4">Company</p>
          <ul className="space-y-2.5">
            <li><Link to="/about" className="text-sm text-slate-300 hover:text-white transition-colors">About Evontra</Link></li>
            <li><Link to="/explore" className="text-sm text-slate-300 hover:text-white transition-colors">Evontra Explore</Link></li>
            <li><Link to="/experiences" className="text-sm text-slate-300 hover:text-white transition-colors">Experiences</Link></li>
            <li><Link to="/contact" className="text-sm text-slate-300 hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} Evontra. All rights reserved.</p>
        <p className="text-xs text-slate-500">Innovate · Integrate · Elevate</p>
      </div>
    </div>
  </footer>
);
